import HeaderSection from '../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../components/CockpitCards/CardTransparent';


export default function MonitoringText() {

    
    return (

    <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Monitor your most important" 
            headline_grey = "cardiovascular"
            headline_p2 = "parameters"

            text1 = "The most important way to prevent atherosclerotic vascular disease, heart failure, and atrial fibrillation is to promote a healthy lifestyle throughout life."
            text2 = "Although there has been substantial improvements cardiovascular diseases remain the leading cause of morbidity and mortality globally. So you better know your essential parameters and manage it."

            />
    }/>
            
  )
}